<template>
  <div ref="container" class="cf-turnstile"></div>
</template>

<script>
export default {
  name: "Turnstile",
  props: {
    siteKey: {
      type: String,
      required: true,
    },
    theme: {
      type: String,
      default: "auto",
    },
    size: {
      type: String,
      default: "flexible",
    },
    tabIndex: {
      type: Number,
      default: 0,
    },
    language: {
      type: String,
      default: "",
    },
    retry: {
      type: Boolean,
      default: true,
    },
    retryInterval: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      widgetId: null,
      elementId: `turnstile-${Math.random().toString(36).substring(2, 15)}`,
    };
  },
  mounted() {
    this.loadTurnstile();
  },
  beforeDestroy() {
    if (window.turnstile && this.widgetId !== null) {
      window.turnstile.remove(this.elementId);
    }
  },
  methods: {
    loadTurnstile() {
      if (window.turnstile) {
        this.renderTurnstile();
      } else {
        if (!document.getElementById("cf-turnstile-script")) {
          const script = document.createElement("script");
          script.id = "cf-turnstile-script";
          script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
          script.async = true;
          script.defer = true;
          script.onload = this.renderTurnstile;
          document.head.appendChild(script);
        } else if (this.retry) {
          // หาก script โหลดอยู่แล้ว แต่ turnstile ยังไม่พร้อม ลองซ้ำ
          const retryRender = setInterval(() => {
            if (window.turnstile) {
              clearInterval(retryRender);
              this.renderTurnstile();
            }
          }, this.retryInterval);
        }
      }
    },
    renderTurnstile() {
      this.widgetId = window.turnstile.render(this.$refs.container, {
        sitekey: this.siteKey,
        theme: this.theme,
        size: this.size,
        tabindex: this.tabIndex,
        language: this.language,
        callback: this.$emit.bind(this, "success"),
        "expired-callback": this.$emit.bind(this, "expired"),
        "error-callback": this.$emit.bind(this, "error"),
      });
    },
    reset() {
      if (window.turnstile && this.widgetId !== null) {
        window.turnstile.reset(this.widgetId);
      }
    },
  },
};
</script>
